import React from 'react';
import { Button } from '../controls/Button.jsx';

/* One sentence explaining what would be here AND WHY IT IS NOT, plus at most one
   action. No illustrations, no exclamation marks, no mascots. */

export function EmptyState({ children, action, onAction, align = 'left', style }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: 'var(--space-12)',
      alignItems: align === 'center' ? 'center' : 'flex-start',
      textAlign: align === 'center' ? 'center' : 'left', padding: 'var(--space-24) 0', ...style,
    }}>
      <p style={{
        margin: 0, maxWidth: '58ch', fontSize: 'var(--body-size)', lineHeight: 'var(--body-line)',
        color: 'var(--text-secondary)',
      }}>{children}</p>
      {action ? <Button onClick={onAction}>{action}</Button> : null}
    </div>
  );
}
